import React from "react";

export default function Week({ Week_text_h2, Week_text_p }) {
  return (
    <section className="week">
      <h2 className="prevention__title">
        {Week_text_h2}
        {/* 23 - 29 июня Неделя профилактики употребления наркотических средств */}
      </h2>
      <p className="prevention__text">
        {Week_text_p}
        {/* Свердловские наркологи ответили на популярные вопросы о диспансерном
        наблюдении */}
      </p>
      {/* <h4 className="prevention__button">
        <a href="/" className="prevention__link">
          Подробнее
        </a>
      </h4> */}
    </section>
  );
}
